import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { useContentOverflow } from '../../../../hooks'
import { FloatingTooltip } from '../../../Floating'
import { IconNG } from '../../../Icon'
import Text from '../../../Text'
import { isPhaseItemStatusFinished } from '../EntityPhase.utils'
import { EntityPhaseItemTooltip } from '../EntityPhaseItemTooltip'

import { ENTITY_PHASE_ITEM_STATUS_ICON_COLOR } from './EntityPhaseItem.constants'

import * as styles from './EntityPhaseItem.module.css'

import DoneIcon from '../../../../icons/done.svg'
import PhaseArrowBackIcon from '../../../../icons/phase-arrow-back.svg'
import PhaseArrowFrontIcon from '../../../../icons/phase-arrow-front.svg'

function EntityPhaseItem({
  backPart,
  className = styles.EntityPhaseItem,
  containerProps,
  disabled,
  frontPart,
  getPhaseStatusText,
  getTooltipAdditionalText,
  id,
  name,
  selected,
  showTooltip,
  status,
  onClick,
}) {
  const { t } = useTranslation()

  const { overflow, setContentOverflowRef } = useContentOverflow()

  function handleClick() {
    if (!disabled) {
      onClick?.(id)
    }
  }

  const itemClassName = classNames(className, styles[status], {
    [styles.clickable]: Boolean(onClick) && !disabled,
    [styles.disabled]: disabled,
    [styles.selected]: selected,
  })

  return (
    <div {...containerProps} className={itemClassName} onClick={handleClick}>
      {backPart ? <PhaseArrowBackIcon className={styles.backPart} /> : null}
      <div className={styles.item}>
        {isPhaseItemStatusFinished(status) ? (
          <IconNG Icon={DoneIcon} color={ENTITY_PHASE_ITEM_STATUS_ICON_COLOR} />
        ) : null}
        <FloatingTooltip
          content={
            <EntityPhaseItemTooltip
              additionalInfo={t(getTooltipAdditionalText({ selected, status }))}
              getPhaseStatusText={getPhaseStatusText}
              name={name}
              status={status}
            />
          }
          disabled={!showTooltip && !overflow}
          placement={FLOATING_ELEMENT_PLACEMENT.top}
        >
          <Text className={styles.name} ref={setContentOverflowRef}>
            {name}
          </Text>
        </FloatingTooltip>
      </div>
      {frontPart ? <PhaseArrowFrontIcon className={styles.frontPart} /> : null}
    </div>
  )
}

export default EntityPhaseItem
